var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-teacher bg-white"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("选择开通服务后最想关注的老师")]), _vm._v(" "), _c('div', {
    staticClass: "icons"
  }, _vm._l((_vm.teacherList), function(item, $index) {
    return _c('div', {
      key: item.enterprise_userid,
      staticClass: "icon",
      class: {
        'active': item.active, 'unactive': !item.active
      },
      on: {
        "click": function($event) {
          _vm.selectTeacher(item, $index)
        }
      }
    }, [_c('div', {
      staticClass: "icon-img"
    }, [_c('img', {
      attrs: {
        "src": item.icon_url,
        "alt": ""
      }
    })]), _vm._v(" "), (item.name.length > 5) ? _c('div', {
      staticClass: "icon-name small"
    }, [_vm._v(_vm._s(item.name))]) : _vm._e(), _vm._v(" "), (item.name.length <= 5) ? _c('div', {
      staticClass: "icon-name"
    }, [_vm._v(_vm._s(item.name))]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.active),
        expression: "item.active"
      }],
      staticClass: "icon-selected"
    }, [_c('img', {
      attrs: {
        "src": "/static/img/selected.png",
        "alt": ""
      }
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "select-teacher-btn",
    on: {
      "click": _vm.selectComplete
    }
  }, [_vm._v("确定")])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.2@vue-loader/lib/template-compiler?{"id":"data-v-92ae2c94","hasScoped":true}!./~/_vue-loader@13.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/customer/OrderSelectTeacher.vue
// module id = 249
// module chunks = 0